export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/2YABfeEFmNc4194fgvxLmD/happy_parenting_mega_kit.webp'

export const HERO_IMAGE_WIDTH = 1382
export const HERO_IMAGE_HEIGHT = 2048

export const ROUTINE_CHARTS_IMAGE =
  'https://cdn.magicpatterns.com/uploads/kaSmYp9qqHG8k8w8NHq8kG/d0b3ed42-41d4-49e8-a336-7bc34d0b602d.png'

export const LIFESTYLE_IMAGE_1 =
  'https://cdn.magicpatterns.com/uploads/jPeL4uJwVxKif1pYS9TbRQ/7d367ec2-6f2d-4eac-a18d-066c85f43f75.png'

export const LIFESTYLE_IMAGE_2 =
  'https://cdn.magicpatterns.com/uploads/keXkTgCzctVHGQo54T7Zkh/f7697f5f-0d08-4b32-9da3-1b28977f7391.png'
